import PAGE_TITLES from './titles'

// GENERATES THE PROPER LOADING TEXT FOR SPECIFIC PAGE
export const getLoadingTitle = (page?: string): string => {
  return page ? 'Loading ' + page + '...' : PAGE_TITLES.LOADING
}
